import { useQuery, useMutation } from 'react-query';
import { request, request_v2 } from '../utils/axios-utils';

export const fetchAllCompanies = data => {
    console.log('fetchAllCompanies', { data });
    const [_blank, pageNum, pageSize, searchText] = data.queryKey;
    const params = {};
    if (!!pageNum) {
        params['pageNum'] = pageNum;
    }
    if (!!pageSize) {
        params['pageSize'] = pageSize;
    }
    if (!!searchText) {
        params['searchText'] = searchText;
    }
    console.log(params);

    return request({
        url: `/company/listing`,
        method: 'GET',
        params: params,
    });
};

export const fetchListingCompanies = () => {
    return request({
        url: `/company/listMinimal`,
        method: 'GET',
    });
};
export const getAllShootTypes = () => {
    return request({
        url: `/util/shootTypes`,
        method: 'GET',
    });
};

export const useGetAllShootTypes = () => {
    return useQuery(['allShootTypes'], getAllShootTypes, {
        refetchOnWindowFocus: false,
        select: data => data.data,
    });
};

const addCompany = company => {
    return request({ url: '/company', method: 'POST', data: company });
};

export const checkUniqueCompanyCode = companyCode => {
    return request({
        url: `/company/companyCodeExists/${companyCode}`,
        method: 'GET',
    });
};
export const checkUniqueBrandCode = brandCode => {
    return request({
        url: `/brand/brandCodeExists/${brandCode}`,
        method: 'GET',
    });
};

const shareCredentials = data => {
    return request({
        url: `/company/${data.id}/getCredsForSFTPViaMail`,
        method: 'POST',
        data: { recipientEmailList: data.emails },
    });
};

export const fetchCompaniesDetailId = id => {
    return request({
        url: `/company/${id}`,
        method: 'GET',
    });
};

export const getCompanyConfig = companyId => {
    return request({
        url: `/company/${companyId}/config`,
        method: 'GET',
    });
};
export const useCheckUniqueCompanyCode = (onSuccess, onError) => {
    return useMutation(checkUniqueCompanyCode, {
        onSuccess: onSuccess,
        onError: onError,
        refetchOnWindowFocus: false,
    });
};
export const useCheckUniqueBrandCode = (onSuccess, onError) => {
    return useMutation(checkUniqueBrandCode, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

export const useGetCompanyConfig = (onSuccess, companyId, enabled = true) => {
    return useQuery(`getCompanyConfig${companyId}`, () => getCompanyConfig(companyId), {
        onSuccess: onSuccess,
        refetchOnWindowFocus: false,
        select: data => data.data,
        enabled: enabled && !!companyId,
    });
};

export const useCompanies = (onSuccess, select) => {
    return useQuery('companies', fetchAllCompanies, {
        refetchOnWindowFocus: false,
        onSuccess: onSuccess,
        retry: (failureCount, error) => failureCount < 3 && error?.response?.status !== 401,
        select: select ? data => select(data.data.data) : data => data.data.data,
    });
};

export const useListingCompanies = (onSuccess, select) => {
    return useQuery('companies', fetchListingCompanies, {
        refetchOnWindowFocus: false,
        onSuccess: onSuccess,
        select: select ? data => select(data.data.data) : data => data.data.data,
    });
};

export const useAddCompany = (onSuccess, onError) => {
    return useMutation(addCompany, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

const updateCompaniesDetails = data => {
    return request({
        url: `/company/${data[0]}`,
        method: 'PATCH',
        data: data[1],
    });
};

export const useUpdateCompanies = (onSuccess, onError) => {
    return useMutation(updateCompaniesDetails, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

const putCompanyConfig = data => {
    return request({
        url: `/company/${data.companyId}/config`,
        method: 'put',
        data: data.companyConfigObj,
    });
};

export const usePutCompanyConfig = (onSuccess, onError) => {
    return useMutation(putCompanyConfig, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

export const getStyleColorRefSettings = (companyId, orderId) => {
    const params = {};
    if (orderId) {
        params.orderId = orderId;
    } else if (companyId) {
        params.companyId = companyId;
    }
    return request({
        url: `/company/styleColorRefSettings`,
        method: 'GET',
        params: params,
    });
};

const putStyleColorRefSettings = data => {
    return request({
        url: `/company/styleColorRefSettings`,
        method: 'put',
        data: data,
    });
};

export const useGetStyleColorRefSettings = (onSuccess, companyId, orderId) => {
    return useQuery(['styleColorRefSettings', companyId, orderId], () => getStyleColorRefSettings(companyId, orderId), {
        onSuccess: onSuccess,
        refetchOnWindowFocus: false,
        select: data => data.data,
    });
};

export const usePutStyleColorRefSettings = (onSuccess, onError) => {
    return useMutation(putStyleColorRefSettings, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

export const getPIIKeys = companyId => {
    return request({
        url: `/company/piiKeys`,
        method: 'GET',
        params: { companyId },
    });
};

const putPIIKeys = data => {
    return request({
        url: `/company/piiKeys`,
        method: 'PUT',
        data,
    });
};

export const useGetPIIKeys = (onSuccess, onError, companyId, enabled = true) => {
    return useQuery(['piiKeys', companyId], () => getPIIKeys(companyId), {
        onSuccess,
        onError,
        refetchOnWindowFocus: false,
        select: data => data.data,
        enabled: enabled && !!companyId,
    });
};

export const useUpdatePIIKeys = (onSuccess, onError) => {
    return useMutation(putPIIKeys, {
        onSuccess,
        onError,
    });
};

export const getProductVariantField = companyId => {
    return request({
        url: `/company/productVariantField`,
        method: 'GET',
        params: { companyId },
    });
};

const putProductVariantField = data => {
    return request({
        url: `/company/productVariantField`,
        method: 'PUT',
        data,
    });
};

export const useGetProductVariantField = (onSuccess, onError, companyId, enabled = true) => {
    return useQuery(['productVariantField', companyId], () => getProductVariantField(companyId), {
        onSuccess,
        onError,
        refetchOnWindowFocus: false,
        select: data => data.data,
        enabled: enabled && !!companyId,
    });
};

export const useUpdateProductVariantField = (onSuccess, onError) => {
    return useMutation(putProductVariantField, {
        onSuccess,
        onError,
    });
};

export const useShareCredentials = (onSuccess, onError) => {
    return useMutation(shareCredentials, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

const markCompanyAsGTOM = async payload => {
    const response = await request({
        url: `/company/markCompanyAsGTOM`,
        method: 'PATCH',
        params: {
            companyCode: payload.companyCode,
        },
        data: {
            isGTOM: payload.isGTOM,
        },
    });
    return response?.data?.data ?? response?.data;
};

export const useMarkCompanyAsGTOM = (onSuccess, onError) => {
    return useMutation(markCompanyAsGTOM, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

const markCompanyAsAutoDDApproval = async payload => {
    const response = await request({
        url: `/company/markCompanyAsAutoDDApproval`,
        method: 'PATCH',
        params: {
            companyCode: payload.companyCode,
        },
        data: {
            isAutoDDApprovalEnabled: payload.isAutoDDApprovalEnabled,
        },
    });
    return response?.data?.data ?? response?.data;
};

export const useMarkCompanyAsAutoDDApproval = (onSuccess, onError) => {
    return useMutation(markCompanyAsAutoDDApproval, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

export const getPatternOptionsById = id => {
    return request({
        url: `company/outputFilenamePatternOptions`,
        method: 'GET',
        params: { id },
    });
};
export const useGetPatternOptionsById = id => {
    return useQuery('getPatternOptionsById', () => getPatternOptionsById(id), {
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => failureCount < 3 && error?.response?.status !== 401,
        select: data => data.data,
    });
};

const GetCompanyListMinimal = async () => {
    const { data } = await request_v2({
        method: 'get',
        url: '/company/listMinimal',
    });
    return data?.data;
};

export const useGetCompanyListMinimal = () =>
    useQuery(['companyListMinimal'], GetCompanyListMinimal, {
        refetchOnWindowFocus: false,
    });

const getCSVFilterData = obj => {
    let osId = obj?.queryKey[1];
    return request({
        url: `/assignment/getFilters/${osId}`,
        method: 'GET',
    });
};

export const useGetCSVFilterData = (onSuccess, onError, osId, isEditingCSV) => {
    return useQuery(['getAllFilterData', osId], getCSVFilterData, {
        onSuccess: onSuccess,
        onError: onError,
        retry: 2,
        enabled: !!isEditingCSV && !!osId,
    });
};
